<script>
    import {External, M} from "../../external";

    export let data, click;

    const count = data.count || (data.id === 'all' ? '' : 0);
    const getSegmentName = function (segment) {
        if (segment.name)
            return External.Tools.escapeIfNeeded(segment.name);
        switch (segment.id) {
            case "cr7":
                return M.CREATED_LAST_7DAYS;
            case "cr30":
                return M.CREATED_LAST_30DAYS;
        }
        return '';
    };
</script>
<li data-filter="{data.id}" class:active={data.active}>
    <a rel="action" data-action="showSegment" on:click={() => click(data)}>
        <span>{getSegmentName(data)}</span>
        <span data-role="filter-count">{count}</span>
    </a>
</li>